export default "__VITE_ASSET__ed7a2972__"